import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=f48e574e&scoped=true&"
import script from "./CreateProfile.vue?vue&type=script&lang=ts&"
export * from "./CreateProfile.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=f48e574e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e574e",
  null
  
)

export default component.exports